import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  /c/10504/outlet

  <span style="color:#85c1dc;">**FI:**</span>
  /c/10504/outlet

  <span style="color:#85c1dc;">**RU:**</span>
  /c/10504/аутлет
*/
/* @__NO_SIDE_EFFECTS__ */
const m1587 = msg(
  mf`/c/10504/outlet`,
  mf`/c/10504/outlet`,
  mf`/c/10504/аутлет`,
)

export { m1587 as 'w.basket.empty.third.link' }